import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { DataServiceService } from 'src/app/services/data-service.service';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { forkJoin, of, Subscription } from 'rxjs';
import { catchError, map, mergeAll } from 'rxjs/operators';
import { VideoCardComponent } from '../_components/video-card/video-card.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SafePipe } from 'src/app/pipes/safe.pipe';

@Component({
    selector: 'app-video-list',
    templateUrl: './video-list.component.html',
    styleUrls: ['./video-list.component.scss'],
    providers: [DataServiceService],
    imports: [VideoCardComponent,RouterModule,CommonModule,SafePipe]

})
export class VideoListComponent implements OnInit, OnDestroy {

  title = "Investing for Catholics latest news and videos.";

  video
  videoHeadline
  videos
  subscriptions = [];
  Keep1stAccordianOpened = false;
  AccordionOpenedState: Array<boolean> = [];
  dropdown:any;
  bootstrap:any;

  constructor(
    private dataservice: DataServiceService, 
    private seoservice: SeoService, 
    private meta: Meta,
    private cdr: ChangeDetectorRef) {

 //  console.log("Video-List > Constructor > forkJoin")


 this.Keep1stAccordianOpened = false;
 this.AccordionOpenedState = [];

  this.subscriptions.push(dataservice.videosByCategory$()
   .subscribe(resp=>{
    
      this.videos = resp.filter((r: any) => r.name != "Most Views");   
        
        for (var x=0; x<this.videos.length; x++)
        {
        if (x==0 && this.videos[x].videos.length > 0)
        {
          this.video = this.videos[x].videos[0];
        }
        //   else
        //     this.AccordionOpenedState.push(true); //Default All to Open, leaving other logic in case
        
          this.AccordionOpenedState[x] = true;
        }
         this.cdr.detectChanges();

   }));

   


   }
  ngOnDestroy(): void {
   this.subscriptions.forEach(x=>x.unsubscribe());
  }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'investing for catholics videos, catholic videos, catholic finance videos, investing catholics videos'});
    this.meta.addTag({name: 'description', content: 'Videos on investing, mutual funds, personal finance, tax options, retirement, tax planning, and financial planning for catholics.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }



}
